import React,{ useEffect,useState } from 'react';
import { getAdvisorAverageRating } from "../shared/_services/common.services";
import StarsIcon from "../styles/StarsIcon";
import { Panel } from "./ui";



const BARS = [[5, "80%"], [4, "60%"], [3, "40%"], [2, "20%"], [1, "10%"]];

const AdvisorReviewsCard = () => {
  const [ratingData, setRatingData] = useState(null);
  const STARS = [1, 2, 3, 4, 5];
  const fetchRatingData = async () => {
    try {
      const response = await getAdvisorAverageRating(JSON.parse(localStorage.getItem('currentUser'))?.user?._id);
      setRatingData(response?.data);
    } catch (error) {
      console.error('Error fetching rating data:', error);
    }
  };

  useEffect(() => {
    fetchRatingData();
  }, []);

  return (
    <Panel>
      <div className="tw-grid tw-gap-6 sm:tw-grid-cols-2">
        <div className="tw-grid tw-content-center tw-gap-3">
          {BARS.map(([star, width]) => (
            <div key={star} className="tw-flex tw-items-center tw-gap-2 tw-text-sm">
              <b className="tw-w-3 tw-tabular-nums">{star}</b>
              <StarsIcon name="starFill" className="tw-h-4 tw-w-4 tw-shrink-0 tw-text-warning" />
              <div className="tw-h-2 tw-flex-1 tw-overflow-hidden tw-rounded-pill tw-bg-surface-sunken">
                <div style={{ width }} className="tw-h-full tw-rounded-pill tw-bg-warning" />
              </div>
            </div>
          ))}
        </div>
        <div className="tw-grid tw-content-center tw-justify-items-end tw-gap-2">
          <h2 className="tw-m-0 tw-text-3xl tw-font-bold tw-tabular-nums tw-text-text">{ratingData?.averageRating}.0</h2>
          <div className="tw-flex tw-gap-1">
            {STARS.map((star) => (
              <StarsIcon
                key={star}
                name={star <= Math.floor(ratingData?.averageRating ?? 0) ? "starFill" : "star"}
                className="tw-h-5 tw-w-5 tw-shrink-0 tw-text-warning"
              />
            ))}
          </div>
          <h6 className="tw-m-0 tw-text-sm tw-font-regular tw-text-text-muted">{ratingData?.reviewsCount} Reviews</h6>
        </div>
      </div>
    </Panel>
  );
};

export default AdvisorReviewsCard;
